export default __webpack_public_path__ + "static/media/landing-blockimg5.48f21646.jpg";